import { ChangePasswordRequest } from "./changePasswordRequest";

export class ResetPasswordRequest extends ChangePasswordRequest{

    public token! : string;

    constructor(){
        super();
    }
}